<template>
  <div>
    <modal
      :name="name"
      height="auto"
      :scrollable="true"
      :clickToClose="false"
      v-bind="modalAttrs"
      v-on="modalListeners"
    >
      <CloseModal :close="handleClose" />
      <div class="modalbox">
        <div class="modalbox-content">
          <CTabs
            variant="tabs"
            class="nav-tabs-boxed"
            :activeTab="activeTabIndex"
            @update:activeTab="handleTabChange"
          >
            <CTab
              v-for="(tab, index) in tabs"
              :key="index"
              :title="tab.title"
              :disabled="tab.disabled || false"
            >
              <slot :name="String(index)" />
            </CTab>
          </CTabs>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import CloseModal from './CloseModal.vue';

export default {
  name: 'ModalWithTabs',
  components: { CloseModal },
  props: {
    name:  { type: String,           required: true },
    width: { type: [String, Number], default: 900 },
    tabs:  { type: Array,            required: true },
  },
  data() {
    return {
      activeTabIndex: 0,
    };
  },
  computed: {
    modalAttrs() {
      return { width: this.width };
    },
    modalListeners() {
      return {
        ...this.$listeners,
        'before-open': this.onBeforeOpen,
      };
    },
  },
  methods: {
    handleClose() {
      this.$modal.hide(this.name);
    },
    onBeforeOpen(event) {
      this.activeTabIndex = 0;
      this.$emit('before-open', event);
    },
    async handleTabChange(newIndex) {
      if (newIndex === this.activeTabIndex) return;

      const previousIndex = this.activeTabIndex;
      const tab = this.tabs[previousIndex];
      const isDirty = tab?.isDirty?.() ?? false;

      if (!isDirty) {
        this.activeTabIndex = newIndex;
        return;
      }

      const hasSave = typeof tab?.onSave === 'function';

      const result = await this.$swal({
        title: 'Alterações não salvas',
        text: 'Esta aba possui alterações não salvas.',
        icon: 'warning',
        showConfirmButton: hasSave,
        confirmButtonText: 'Salvar',
        showDenyButton: true,
        denyButtonText: 'Descartar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        try {
          const success = await tab.onSave();
          if (success !== false) {
            await this.$swal({
              title: 'Salvo com sucesso',
              icon: 'success',
              showConfirmButton: true,
              showCancelButton: false,
            });
            this.activeTabIndex = newIndex;
          } else {
            await this.$swal({
              title: 'Falha ao salvar',
              text: 'Não foi possível salvar as alterações.',
              icon: 'error',
            });
            await this._forceTabBack(newIndex, previousIndex);
          }
        } catch (err) {
          await this.$swal({
            title: 'Falha ao salvar',
            text: err.message || 'Não foi possível salvar as alterações.',
            icon: 'error',
          });
          await this._forceTabBack(newIndex, previousIndex);
        }
      } else if (result.isDenied) {
        tab?.onDiscard?.();
        this.activeTabIndex = newIndex;
      } else {
        // isDismissed (cancelar) → voltar para aba anterior
        await this._forceTabBack(newIndex, previousIndex);
      }
    },
    async _forceTabBack(newIndex, previousIndex) {
      // O CTabs já está visualmente em newIndex (estado interno do componente).
      // Para fazê-lo voltar para previousIndex, precisamos forçar Vue a detectar
      // uma mudança: setamos para newIndex (no-op visual), depois para previousIndex.
      this.activeTabIndex = newIndex;
      await this.$nextTick();
      this.activeTabIndex = previousIndex;
    },
  },
};
</script>
